import { CommunityServiceCategoryService } from 'src/app/core/service/community-service-category.service';
import { Injectable } from '@angular/core';
import { UntypedFormControl } from '@angular/forms';

@Injectable({
    providedIn: 'root'
})
export class CommunityServiceCategoryValidators
{
    constructor(private communityServiceCategoryService: CommunityServiceCategoryService) { }

    public validateCommunityServiceCategoryNameUnique(serviceCategoryId: number | null,
        nameControl: UntypedFormControl, initialName: string,
        serviceTypeControl: UntypedFormControl, initialServiceType: any): any
    {
        return new Promise(resolve =>
        {
            if (nameControl && serviceTypeControl && nameControl.value && serviceTypeControl.value && serviceTypeControl.value?.id &&
                (initialName !== nameControl.value || initialServiceType !== serviceTypeControl.value?.id))
            {
                this.communityServiceCategoryService.existsCommunityServiceCategoryName(serviceCategoryId,
                    nameControl.value, serviceTypeControl.value.id).subscribe({
                        next: (response) =>
                        {
                            if (response)
                            {
                                resolve({ nameExists: true });
                            }
                            else
                            {
                                resolve(null);
                            }
                        }
                    });
            }
            else
            {
                resolve(null);
            }
        });
    }
}
